// Team-Daten — anpassbar mit echten Fotos und Texten
export const teamMembers = [
  {
    id: 1,
    name: 'Simon Nabhan',
    suffix: 'LL.M.',
    role: 'Rechtsanwalt · Partner',
    title: 'Gründungspartner',
    image: '/assets/team/simon-nabhan.png',
    bio: 'Spezialisiert auf Ausländerrecht und Strafverteidigung. Seit über 10 Jahren vor den Gerichten in Bonn und Köln im Einsatz. Bekannt für durchsetzungsstarke Vertretung in komplexen Aufenthalts- und Einbürgerungsverfahren.',
    expertise: ['Ausländerrecht', 'Strafrecht', 'Einbürgerung'],
    languages: ['Deutsch', 'Englisch', 'Arabisch'],
    education: ['1. Staatsexamen Köln', '2. Staatsexamen NRW'],
    phone: '+49 (0) 228 30 40 64-0',
    email: 'nabhan@kanzlei-partner.com',
  },
  {
    id: 2,
    name: 'Christian Nabhan',
    suffix: 'LL.M.',
    role: 'Rechtsanwalt · Partner',
    title: 'Gründungspartner',
    image: '/assets/team/christian-nabhan.png',
    bio: 'Schwerpunkt im Wirtschafts- und Verwaltungsrecht. Begleitet Gründer und Mittelständler bei Gesellschaftsgründungen, Vertragsgestaltung und Streitbeilegung. Lehrbeauftragter an der Hochschule Bonn-Rhein-Sieg.',
    expertise: ['Gesellschaftsrecht', 'Verwaltungsrecht', 'Wirtschaftsrecht'],
    languages: ['Deutsch', 'Englisch', 'Arabisch'],
    education: ['1. Staatsexamen Bonn', '2. Staatsexamen NRW', 'LL.M.'],
    phone: '+49 (0) 228 30 40 64-0',
    email: 'c.nabhan@kanzlei-partner.com',
  },
  {
    id: 3,
    name: 'Gerd Gäbler',
    role: 'Steuerberater · Betriebswirt · Partner',
    title: 'Gründungspartner',
    image: '/assets/team/gerd-gaebler.jpg',
    bio: 'Diplom-Betriebswirt und bestellter Steuerberater. Vertritt mittelständische Unternehmen vor dem Finanzamt und bei Betriebsprüfungen. Spezialist für internationale Besteuerung und Steueroptimierung.',
    expertise: ['Steuerberatung', 'Steuerrecht', 'Gesellschaftsrecht'],
    languages: ['Deutsch', 'Englisch', 'Italienisch'],
    education: ['Diplom-Betriebswirt', 'Steuerberaterexamen'],
    phone: '+49 (0) 228 30 40 64-0',
    email: 'gaebler@kanzlei-partner.com',
  },
  {
    id: 4,
    name: 'Bashar Mardini',
    role: 'Rechtsanwalt',
    title: 'Team',
    image: '/assets/team/bashar-mardini.jpg',
    bio: 'Mehrsprachiger Rechtsanwalt mit Fokus auf Ausländer- und Aufenthaltsrecht sowie Strafverteidigung. Vertritt Mandanten aus dem arabischsprachigen Raum mit kulturellem Feingefühl und juristischer Präzision.',
    expertise: ['Ausländerrecht', 'Strafrecht', 'Aufenthaltsrecht'],
    languages: ['Deutsch', 'Englisch', 'Arabisch'],
    education: ['1. Staatsexamen', '2. Staatsexamen NRW'],
    phone: '+49 (0) 228 30 40 64-0',
    email: 'b.mardini@kanzlei-partner.com',
  },
  {
    id: 5,
    name: 'Arta Tairi',
    role: 'Mitarbeiterin',
    title: 'Team',
    image: '/assets/team/arta-tairi.jpg',
    languages: ['Deutsch', 'Englisch', 'Albanisch'],
    phone: '+49 (0) 228 30 40 64-0',
    email: 'tairi@kanzlei-partner.com',
  },
];

export const teamSupportStaff = [
  { name: 'Lisa Schäfer', role: 'Rechtsanwaltsfachangestellte', icon: 'user' },
  { name: 'Maria Hoffmann', role: 'Steuerfachangestellte', icon: 'user' },
  { name: 'Andreas Weber', role: 'Buchhaltung', icon: 'user' },
];
